import React from 'react';
import { MessageSquareTextIcon, FileCheckIcon, GraduationCapIcon, CalendarCheckIcon } from 'lucide-react';
export function SolutionSection() {
  const benefits = [{
    icon: MessageSquareTextIcon,
    text: 'Pedí documentación sin rogar ni improvisar'
  }, {
    icon: FileCheckIcon,
    text: 'Scripts y plantillas listos para cada situación'
  }, {
    icon: GraduationCapIcon,
    text: 'Educá a tus clientes desde el día uno'
  }, {
    icon: CalendarCheckIcon,
    text: 'Cerrá el mes sin perseguir a nadie'
  }];
  return <section className="py-6 bg-[#1e3a5f] text-white" data-id="element-186">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-188">
          <div className="md:w-1/3 text-center md:text-left" data-id="element-189">
            <h2 className="text-xl md:text-2xl font-black text-[#d4a017] leading-tight mb-2" data-id="element-190">
              Con Sistema PRO: Cero Persecución vas a poder:
            </h2>
            <p className="text-xs text-gray-300" data-id="element-191">
              Sistema PRO: Cero Persecución fue creado para resolver exactamente
              estos problemas.
            </p>
          </div>

          <div className="md:w-2/3 grid grid-cols-2 md:grid-cols-3 gap-3" data-id="element-192">
            {benefits.map((b, i) => <div key={i} className="flex items-center gap-2 bg-white/5 rounded-lg p-2.5 border border-white/10" data-id="element-193">
                <b.icon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-194" />
                <p className="text-[11px] font-medium text-gray-100 leading-tight" data-id="element-195">
                  {b.text}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}